/* unplugin-vue-components disabled */import __unplugin_components_11 from 'F:/bio_link_pc/src/components/common/clientProjectDialog.vue';
import { ElDialog as __unplugin_components_10 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/dialog/style/css';
import { ElForm as __unplugin_components_9 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/form/style/css';
import { ElUpload as __unplugin_components_8 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/upload/style/css';
import { ElButton as __unplugin_components_7 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/button/style/css';
import { ElRadioGroup as __unplugin_components_6 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/radio-group/style/css';
import { ElRadio as __unplugin_components_5 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/radio/style/css';
import { ElDatePicker as __unplugin_components_4 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/date-picker/style/css';
import { ElSelect as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/select/style/css';
import { ElOption as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/option/style/css';
import { ElFormItem as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/form-item/style/css';
import { ElInput as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/input/style/css';
import _asyncToGenerator from "F:/bio_link_pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, isRef as _isRef } from "vue";
var _hoisted_1 = {
  class: "link"
};
var _hoisted_2 = {
  style: {
    "display": "flex",
    "width": "100%",
    "justify-content": "space-between"
  }
};
var _hoisted_3 = {
  key: 1
};
var _hoisted_4 = {
  style: {
    "color": "orange",
    "text-align": "left"
  }
};
var _hoisted_5 = {
  key: 0,
  style: {
    "text-align": "left"
  }
};
var _hoisted_6 = ["onClick"];
var _hoisted_7 = {
  class: "footer"
};
var _hoisted_8 = {
  key: 0
};
import { systemType } from "@/constants";
import { reactive, watchEffect } from "vue";
import { get_user_list, create_link, get_link, create_group_link, get_group_link, change_link, client, gettuserlist, get_client_project } from "@/api/apis";
import { useTimStore } from "@/store/tim";
import { useUserStore } from "@/store/user";
import { removeRepeatKeyInArrKey, getdelaydays, format } from "@/util/index.js";
import { createCustomerGroup, getlink_group_id, getMmemberList, get_link_user_list } from "@/util/link";
import { TUIGroupService, TUIUserService } from "@tencentcloud/chat-uikit-engine";
import router from "@/router";
import sampleDialog from "@/views/work_bench/link_todo/sample.vue";
import { ElMessage } from "element-plus";
import { toTimeStamp } from "@/util/index";
import { usecommonStore } from "@/store/common";
export default {
  __name: 'add',
  props: ["currentConversation", "linkParams"],
  emits: ["handle_close_linkDialog", "updateList"],
  setup(__props, _ref) {
    var {
      emit: __emit
    } = _ref;
    var commonStore = usecommonStore();
    var fileList = ref([]);
    var selectpeople = ref("");
    var emit = __emit;
    var TimStore = useTimStore();
    var userStore = useUserStore();
    var action = process.env.VUE_APP_BASE_URL + "/api/file/add_file";
    var headers = {
      "system-type": systemType,
      Authorization: "Bearer " + localStorage.getItem("token_blk")
    };
    // 时间选择快捷选项
    var shortcuts = [{
      text: "一天后",
      value: () => {
        var date = new Date();
        date.setTime(date.getTime() + 3600 * 1000 * 24);
        console.log("date-->", date);
        return date;
      }
    }, {
      text: "两天后",
      value: () => {
        var date = new Date();
        date.setTime(date.getTime() + 3600 * 1000 * 24 * 2);
        return date;
      }
    }, {
      text: "一周后",
      value: () => {
        var date = new Date();
        date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
        return date;
      }
    }];
    var dataOwn = reactive({
      userList: [],
      //选择的用户列表
      isClickable: true,
      //是否可点击的 用于限制表单多次提交
      link_id: "",
      //待办的id
      customMessageType: "",
      source_id: "",
      submitTxt: "发布",
      clientName: "",
      //
      originLinkDeatil: {},
      //有linkid是获取的初始详情数据
      fromGroup: false,
      //是否来自群组，默认false
      customMessageType: "",
      showDialogSample: false,
      //是否展示选择样品申请单
      clientID: "",
      //客户id
      isMoreLink: false //是否是一键改图
    });
    var linkformref = ref(""); //用于表单验证
    var props = __props;
    var mappingGroupList = [{
      name: "张斌",
      id: 340
    }];
    var planGroupList = [{
      name: "董金华",
      id: 338
    }];
    var bomGroupList = [{
      name: "张斌",
      id: 340
    }, {
      name: "张鑫洁",
      id: 596
    }];
    var user = {
      id: Number(userStore.info.id),
      name: userStore.info.name
    };
    // 销售员
    var saleGroupList = [user];

    //制图
    //薛于航：广州、上海、杭州（是配到浙江吗）、济南（山东）、海南
    //洪宇：武汉、成都、江苏、北京、长春 （吉林）,四川
    //吕婷：海外

    //文员
    //张斌及张鑫洁

    var linkform = reactive({
      theme: "",
      //主题
      title: "",
      //描述
      date: "",
      //link时间
      file_ids: [],
      user_ids: [],
      source: "",
      //默认6 直接建群  //1 线索 2商机 3客户 4产品 5样品  6直接建群 7定制品
      group_id: "",
      //群组id
      origin_id: "",
      //冗余id source为1,2,3时为客户id 5时返厂为样品申请单id 6时为0
      sales_dept_id: "",
      //客户区域id
      view_status: "",
      //可见类型 1全部 2.仅待办参与人
      type: 1,
      ////1=link 2=demo返厂 3=定制品待办,
      source_name: "",
      //link来源
      sample: {},
      //这个字段不需要传给后端，只有在demo申请时这个字段必填之后赋值给origin_id
      view_drawing: 2,
      client_project_id: null
    });
    var route = useRoute();

    // 获取当前时间之后的30天
    var getdelaynormal = daycount => {
      // 获取当前时间
      var currentDate = new Date();

      // 创建一个新的日期对象，用于存储推迟后的时间
      var futureDate = new Date(currentDate);

      // 将日期推迟30天
      futureDate.setDate(currentDate.getDate() + daycount);
      return format(futureDate.getTime() / 1000);
    };
    var handleSetUserids = type => {
      if (!type) return;
      if (type == 1) {
        linkform.view_status = 2;
        console.log("userStore.info--->", userStore.info);
        linkform.user_ids = [{
          title: "",
          type: 1,
          finish_time: "",
          userids: [userStore.info.name + "-" + userStore.info.id]
        }];
      }
      if (type == 2) {
        linkform.view_status = 2;
        linkform.user_ids = [{
          title: "填写物流单号",
          type: 2,
          finish_time: "",
          userids: []
        }, {
          title: "确认收货",
          type: 3,
          finish_time: "",
          userids: []
        }];
      } else if (type == 3) {
        linkform.view_status = 1;
        linkform.date = getdelaynormal(30);
        linkform.user_ids = [{
          title: "上传产品图纸",
          type: 4,
          finish_time: getdelaydays(2),
          userids: mappingGroupList.map(x => x.name + "-" + x.id)
        }, {
          title: "生成BOM清单",
          type: 5,
          finish_time: getdelaydays(4),
          userids: bomGroupList.map(x => x.name + "-" + x.id)
        },
        // {
        //     title: "销售确认图纸方案",
        //     type: 8,
        //     finish_time: getdelaydays(4),
        //     userids: saleGroupList.map((x) => x.name + "-" + x.id),
        // },
        {
          title: "确认BOM系数",
          type: 7,
          finish_time: getdelaydays(5),
          userids: planGroupList.map(x => x.name + "-" + x.id)
        }, {
          title: "上传客户签名图纸",
          type: 6,
          finish_time: getdelaynormal(30),
          userids: saleGroupList.map(x => x.name + "-" + x.id)
        }];
      }
    };

    // 根据任务类型获取当前延期时间
    var getdelayfromType = type => {
      switch (type) {
        case 4:
          return getdelaydays(2);
        case 5:
          return getdelaydays(4);
        case 8:
          return getdelaydays(4);
        case 7:
          return getdelaydays(4);
        case 6:
          return getdelaynormal(30);
        default:
          return getdelaynormal(30);
      }
    };
    var getDetail = link_id => {
      get_link({
        id: link_id
      }).then(res => {
        var link_detail = res.data.list[0] || {};
        linkform.group_id = link_detail.group_id;
        if (link_detail.type == 3) {
          getUserList();
          // get_link_user_list(link_detail.sales_dept_id).then(list => {
          //     dataOwn.userList = list
          //     // 看下创建者在不在客户区域列表，不在就塞进去
          //     let arr = dataOwn.userList.filter(x => x.name == userStore.info.name);
          //     if (!arr || !arr[0]) {
          //         dataOwn.userList.push(userStore.info);
          //     }
          // })
        } else {
          getMmemberList(linkform.group_id).then(member => {
            console.log("member->", member);
            dataOwn.userList = member;
            dataOwn.userList = dataOwn.userList.forEach(x => {
              x.value_show = x.name + "-" + x.id;
            });
          });
        }
        Object.keys(linkform).map(key => {
          linkform[key] = link_detail[key];
        });
        if (link_detail.type == 2) {
          linkform.sample = {
            id: link_detail.origin_id,
            bills_code: link_detail.bills_code
          };
        }
        if (dataOwn.isMoreLink) {
          linkform["title"] = "";
        } else {
          linkform.file_ids = link_detail.file;
          fileList.value = link_detail.file.map(x => {
            return {
              name: x.name,
              url: x.file_url
            };
          });
        }
        // 如果是二次创建待办 预期完成时间重新赋值
        var date_;
        if (dataOwn.isMoreLink) {
          date_ = getdelaynormal(30);
          linkform.date = date_;
          linkform.file_ids = [];
        }
        var temp_arr = JSON.parse(JSON.stringify(link_detail.user));
        var result = Object.values(temp_arr.reduce((acc, cur) => {
          if (!acc[cur.task_id]) {
            acc[cur.task_id] = {
              task_id: cur.task_id,
              userids: [],
              title: cur.title,
              type: cur.type,
              finish_time: dataOwn.isMoreLink ? getdelayfromType(cur.type) : cur.finish_time
            };
          }
          acc[cur.task_id].userids.push(cur.user_name + "-" + cur.link_user_id);
          return acc;
        }, {}));
        linkform.user_ids = result;
        // 判断是否是有销售确认这个环节 没有的话添加进去
        // let index_salerok = linkform["user_ids"].findIndex((x) => x.type == 8);

        // if (index_salerok == -1) {
        //     linkform['user_ids'].splice(2, 0, {
        //         title: "销售确认图纸方案",
        //         type: 8,
        //         finish_time: '',
        //         userids: [],
        //     });
        //     let index_saler = linkform["user_ids"].findIndex(x => x.type == 6);
        //     let index_plan = linkform["user_ids"].findIndex(x => x.type == 7);
        //     linkform['user_ids'][2]['finish_time'] = linkform['user_ids'][index_plan]['finish_time']
        //     linkform['user_ids'][2]['userids'] = linkform['user_ids'][index_saler]['userids']
        // }
        if (link_detail.status == 4) {
          linkform["status"] = 1;
        }
        dataOwn.originLinkDeatil = JSON.parse(JSON.stringify(linkform));
      });
    };
    var getUserList = () => {
      return new Promise((resolve, reject) => {
        var obj = {
          page: 1,
          limit: 1,
          is_simple: 1
        };
        get_user_list(obj).then(res => {
          get_user_list({
            paga: 1,
            limit: res.data.total,
            is_simple: 1
          }).then(res_ => {
            var arr = res_.data.data || [];
            if (arr && arr[0]) {
              arr.forEach(x => x.value_show = x.name + "-" + x.id);
            }
            dataOwn.userList = Array.from(arr);
            resolve(dataOwn.userList);
          });
        }).catch(err => {
          reject(err);
        });
      });
    };
    //获取客户项目
    var client_project_list = ref([]);
    var getClientProjects = function getClientProjects(id) {
      var is_default = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      get_client_project({
        client_id: id
      }).then(res => {
        if (res.code == 200) {
          client_project_list.value = res.data || [];
          if (is_default) {
            var _client_project_list$;
            linkform.client_project_id = (_client_project_list$ = client_project_list.value[0]) === null || _client_project_list$ === void 0 ? void 0 : _client_project_list$.id;
          }
        }
      });
    };
    var showDialog = ref(false);
    //新增客户项目
    var addClientProject = () => {
      showDialog.value = true;
    };
    var handle_close_client = type => {
      showDialog.value = false;
      getClientProjects(props.linkParams.client_id, type == "add" ? true : false);
    };
    watchEffect(() => {
      if (props.linkParams) {
        var _props$linkParams, _props$linkParams2;
        console.log("props.linkParams", props.linkParams);
        if (props.linkParams.theme) {
          dataOwn.clientName = props.linkParams.theme;
        }
        dataOwn.isMoreLink = (_props$linkParams = props.linkParams) === null || _props$linkParams === void 0 ? void 0 : _props$linkParams.isMoreLink;
        dataOwn.fromGroup = props.linkParams.fromGroup;
        dataOwn.customMessageType = props.linkParams.customMessageType;
        linkform.type = props.linkParams.customMessageType == "material_customization" ? 3 : props.linkParams.customMessageType == "demo" ? 2 : 1;
        linkform.source = props.linkParams.source;
        linkform.origin_id = props.linkParams.origin_id;
        linkform.source_name = props.linkParams.source_name;
        linkform.sales_dept_id = props.linkParams.sales_dept_id;
        dataOwn.source_id = props.linkParams.source_id;
        if ((_props$linkParams2 = props.linkParams) !== null && _props$linkParams2 !== void 0 && _props$linkParams2.project_show) {
          getClientProjects(props.linkParams.client_id, true);
        }
        // 根据orogin_id获取群组关联
        if (dataOwn.fromGroup) {
          console.log("是从客户群组进来的啊");
          // 如果是从群组进来的 通过监听当前对话props.currentConversation 获取用户列表 是新建待办

          linkform.group_id = props.currentConversation.groupProfile.groupID;
          if (linkform.source == 3 || linkform.source == 7 || linkform.source == 5) {
            // 如果是物料定制或者source=3的时候 需要获取群组关联的客户id
            get_group_link({
              group_id: linkform.group_id
            }).then(res => {
              var _res$data;
              if (res.data && (_res$data = res.data) !== null && _res$data !== void 0 && _res$data.list[0]) {
                console.log("获取群组关联的客户id->", res.data.list[0].client);
                if (linkform.source == 3 || linkform.source == 7) {
                  var _res$data$list$, _res$data$list$2, _res$data$list$3, _res$data$list$4;
                  dataOwn.source_id = (_res$data$list$ = res.data.list[0]) === null || _res$data$list$ === void 0 || (_res$data$list$ = _res$data$list$.client) === null || _res$data$list$ === void 0 ? void 0 : _res$data$list$.id;
                  linkform.origin_id = (_res$data$list$2 = res.data.list[0]) === null || _res$data$list$2 === void 0 || (_res$data$list$2 = _res$data$list$2.client) === null || _res$data$list$2 === void 0 ? void 0 : _res$data$list$2.id;
                  linkform.sales_dept_id = (_res$data$list$3 = res.data.list[0]) === null || _res$data$list$3 === void 0 || (_res$data$list$3 = _res$data$list$3.client) === null || _res$data$list$3 === void 0 ? void 0 : _res$data$list$3.sales_dept_id;
                  linkform.source_name = (_res$data$list$4 = res.data.list[0]) === null || _res$data$list$4 === void 0 || (_res$data$list$4 = _res$data$list$4.client) === null || _res$data$list$4 === void 0 ? void 0 : _res$data$list$4.company;
                } else {
                  dataOwn.clientID = res.data.list[0].client.id;
                }
                console.log("linkform->", linkform);
              }
            });
          }
          if (linkform.type == 2) {
            linkform.source = 5;
          } else if (linkform.type == 3) {
            linkform.source = 7;
            // 如果是定制品待办 期望完成时间往后延迟两天 周末及节假日跳过
          }
          getMmemberList(linkform.group_id).then(member => {
            console.log("member->", member);
            member.forEach(x => x.value_show = x.name + "-" + x.id);
            dataOwn.userList = member;
            handleSetUserids(linkform.type);
          });
        } else if (props.linkParams.link_id) {
          dataOwn.link_id = props.linkParams.link_id;
          getDetail(dataOwn.link_id);
        } else if (linkform.origin_id && (linkform.source == 3 || linkform.source == 2 || linkform.source == 1 || linkform.source == 5 && linkform.type == 1)) {
          console.log("linkform.origin_id 是的来啦->", linkform.origin_id);
          console.log("linkform--->", linkform);
          // 从客户线索商机样品等列表link按钮进来的 也是创建待办 type=1 普通待办
          getlink_group_id(linkform.origin_id).then(res => {
            console.log("group_id 根据客户id关联出来的群组id--->", res);
            if (res) {
              linkform.group_id = res;
              getMmemberList(linkform.group_id).then(member => {
                member.forEach(x => x.value_show = x.name + "-" + x.id);
                console.log("member->", member);
                dataOwn.userList = member;
                handleSetUserids(linkform.type);
              });
            }
          }).catch(err => {
            console.log("err没得获取到或获取失败->", err);
            console.log("群组不存在-》获取客户区域下面的人员列表");
            get_link_user_list(linkform.sales_dept_id).then(list => {
              dataOwn.userList = list;

              // 看下创建者在不在客户区域列表，不在就塞进去
              var arr = dataOwn.userList.filter(x => x.name == userStore.info.name);
              if (!arr || !arr[0]) {
                dataOwn.userList.push(userStore.info);
              }
              dataOwn.userList.forEach(x => {
                x.value_show = x.name + "-" + x.id;
              });
            });
            handleSetUserids(linkform.type);
            // 群组已解散或已不存在 需重创建客户群组 (这一步暂时不需要了 因为在发布的时候也做了群组id没有时的创建工作)
          });
        } else if (linkform.origin_id && linkform.type == 3) {
          console.log("客户列表创建定制品待办");
          var dept_info_name = props.linkParams.dept_info_name; //客户列表传过来的客户区域name

          getUserList().then(res => {
            var white_xueyuhhang = ["广州", "上海", "杭州", "济南", "海南"];
            var white_hongyu = ["成都", "武汉", "江苏", "北京", "吉林", "四川"];
            client({
              id: linkform.origin_id,
              interface: 2
            }).then(res => {
              var _res$data2, _res$data3, _res$data4, _res$data$user_info;
              var namestr = (_res$data2 = res.data) === null || _res$data2 === void 0 || (_res$data2 = _res$data2.user_info) === null || _res$data2 === void 0 || (_res$data2 = _res$data2.sales_company_info[0]) === null || _res$data2 === void 0 ? void 0 : _res$data2.drawer_name;
              var idstr = (_res$data3 = res.data) === null || _res$data3 === void 0 || (_res$data3 = _res$data3.user_info) === null || _res$data3 === void 0 || (_res$data3 = _res$data3.sales_company_info[0]) === null || _res$data3 === void 0 ? void 0 : _res$data3.drawer_id;
              console.log({
                idstr
              });
              if (idstr && idstr.length > 0) {
                var arr = [];
                idstr.split(",").map((x, i) => {
                  arr.push({
                    name: namestr.split(",")[i],
                    id: x
                  });
                });
                console.log({
                  arr
                });
                mappingGroupList = arr;
              }
              var dept_info = ((_res$data4 = res.data) === null || _res$data4 === void 0 ? void 0 : _res$data4.dept_info) || {};
              var saleuserid = ((_res$data$user_info = res.data.user_info) === null || _res$data$user_info === void 0 ? void 0 : _res$data$user_info.id) || "";
              var saleuserinfo = res.data.user_info;
              if (saleGroupList.findIndex(x => x.id == saleuserid) == -1) {
                saleGroupList.push(saleuserinfo);
              }
              if (dept_info && dept_info.id) {
                gettuserlist({
                  sale_area_id: dept_info.id,
                  name: "区域助理"
                }).then(res => {
                  var _res$data5;
                  var quyumanger = ((_res$data5 = res.data) === null || _res$data5 === void 0 ? void 0 : _res$data5.list) || [];
                  quyumanger.map(x => {
                    if (saleGroupList.findIndex(m => m.id == x.id) == -1 && x.role_type == 2) {
                      saleGroupList.push({
                        name: x.user_name,
                        id: x.user_id
                      });
                    }
                  });
                  handleSetUserids(linkform.type);
                });
              } else {
                handleSetUserids(linkform.type);
              }

              // if (props.linkParams?.sale_user_info?.id) {
              //     if (
              //         saleGroupList.findIndex(
              //             (x) => x.id == props.linkParams.sale_user_info?.id
              //         ) == -1
              //     ) {
              //         saleGroupList.push(props.linkParams.sale_user_info);
              //     }
              // }

              // handleSetUserids(linkform.type);
            });

            // if (dept_info_name == "海外") {
            //     mappingGroupList = [
            //         {
            //             name: "吕婷",
            //             id: 470,
            //         },
            //     ];
            // } else if (white_xueyuhhang.indexOf(dept_info_name) != -1) {
            //     mappingGroupList = [
            //         {
            //             name: "薛于航",
            //             id: 189,
            //         },
            //     ];
            // } else if (white_hongyu.indexOf(dept_info_name) != -1) {
            //     mappingGroupList = [
            //         {
            //             name: "洪宇",
            //             id: 285,
            //         },
            //     ];
            // }
            // mappingGroupList.map(x => {
            //     if (dataOwn.userList.findIndex(a => a.id == x.id) == -1) {
            //         dataOwn.userList.push(x);
            //     }
            // })

            // if (saleGroupList.findIndex((x) => x.id == 310) == -1) {
            //     saleGroupList.push({
            //         name: "顾菁",
            //         id: 310,
            //     });
            // }
          });

          // get_link_user_list(linkform.sales_dept_id).then(list => {
          //     dataOwn.userList = list;
          //     // 创建者在不在客户区域列表，不在就塞进去
          //     let arr = dataOwn.userList.filter(x => x.name == userStore.info.name);
          //     if (!arr || !arr[0]) {
          //         dataOwn.userList.push(userStore.info);
          //     }
          //     const white_xueyuhhang = ['广州', '上海', '杭州', '济南', '海南']
          //     const white_hongyu = ['成都', '武汉', '江苏', '北京', '吉林', '四川']

          //     if (dept_info_name == '海外') {
          //         mappingGroupList = [{
          //             name: "吕婷",
          //             id: 470
          //         }]
          //     } else if (white_xueyuhhang.indexOf(dept_info_name) != -1) {
          //         mappingGroupList = [{
          //             name: "薛于航",
          //             id: 189
          //         }]
          //     } else if (white_hongyu.indexOf(dept_info_name) != -1) {
          //         mappingGroupList = [{
          //             name: "洪宇",
          //             id: 285
          //         }]
          //     }
          //     mappingGroupList.map(x => {
          //         if (dataOwn.userList.findIndex(a => a.id == x.id) == -1) {
          //             dataOwn.userList.push(x);
          //         }
          //     })
          //     if (props.linkParams?.sale_user_info?.id) {
          //         if (saleGroupList.findIndex(x => x.id == props.linkParams.sale_user_info?.id) == -1) {
          //             saleGroupList.push(props.linkParams.sale_user_info);
          //         }
          //     }

          //     handleSetUserids(linkform.type);
          // })
        } else {
          console.log("进入这里了咯");
          getUserList();
          handleSetUserids(linkform.type);
        }
      }
    });

    // 获取label
    var getTypeLabel = type => {
      if (type == 2) {
        return "售后";
      } else if (type == 3) {
        return "测试组";
      } else if (type == 4) {
        return "制图";
      } else if (type == 5) {
        return "文员";
      } else if (type == 6) {
        return "销售员";
      } else if (type == 7) {
        return "计划";
      } else if (type == 8) {
        return "销售员";
      }
      return dataOwn.customMessageType == "material_customization" ? "自定义" : "";
    };
    var checkUserIds = (rule, value, callback) => {
      if (!value || !value[0]) {
        callback(new Error("任务不能为空"));
      } else {
        var count = 0;
        var error_title = "任务执行人/截止时间/任务内容均不能为且子任务截至时间应小于Link截至时间";
        value.map(x => {
          if (!x.finish_time || !x.title || !x.userids || !x.userids[0] || x.finish_time && linkform.date && toTimeStamp(x.finish_time) > toTimeStamp(linkform.date)) {
            count += 1;
          }
          if (!x.userids || !x.userids[0]) {
            console.log("任务执行人不能为空啦啦啦", x.userids);
            error_title = "任务执行人不能为空";
          } else if (!x.title) {
            error_title = "任务内容不能为空";
          } else if (!x.finish_time) {
            error_title = "任务截止时间不能为空";
          } else if (x.finish_time && linkform.date && toTimeStamp(x.finish_time) > toTimeStamp(linkform.date)) {
            error_title = "子任务截止时间应小于Link截止时间";
          }
        });
        if (count > 0) {
          console.log("count>0", count);
          console.log("errorttitle--->", error_title);
          callback(new Error(error_title));
        } else {
          callback();
        }
      }
    };
    var checkDate = (rule, value, callback) => {
      var count = 0;
      var error_title;
      if (value) {
        linkform.user_ids.map(x => {
          if (x.finish_time && toTimeStamp(x.finish_time) > toTimeStamp(value)) {
            count += 1;
            error_title = "Link截止时间应大于子任务截止时间";
          }
        });
      } else {
        count = 1;
        error_title = dataOwn.customMessageType == "demo" ? "样品返厂时间不能为空" : dataOwn.customMessageType == "material_customization" ? "期望完成时间不能为空" : "截止时间不能为空";
      }
      if (count > 0) {
        callback(new Error(error_title));
      } else {
        callback();
      }
    };
    var rules = reactive({
      theme: [{
        required: true,
        message: "待办主题不能为空",
        trigger: ["blur", "change"]
      }],
      client_project_id: [{
        required: true,
        message: "请选择客户项目",
        trigger: ["blur", "change"]
      }],
      title: [{
        required: true,
        message: dataOwn.customMessageType == "demo" ? "样品返厂原因不能为空" : dataOwn.customMessageType == "material_customization" ? "客户需求" : "待办描述",
        trigger: ["blur", "change"]
      }],
      date: [{
        // required: true,
        // message: dataOwn.customMessageType == "demo" ? "样品返厂时间不能为空" : dataOwn.customMessageType == "material_customization" ? "期望完成时间不能为空" : "截止时间不能为空",
        trigger: ["blur", "change"],
        validator: checkDate
      }],
      user_ids: [{
        validator: checkUserIds,
        trigger: ["blur", "change"]
      }]
    });
    var handleFileRemove = file => {
      console.log("file--->", file);
      var index = linkform.file_ids.findIndex(x => x.file_url == file.url && x.name == file.name);
      if (index != -1) {
        linkform.file_ids.splice(index, 1);
      }
    };
    // 上传成功
    var handleFileSuccess = (res, file) => {
      console.log("上传文件成功->", res, file);
      linkform.file_ids.push({
        file_id: res.data.file_id,
        name: file.name,
        file_url: res.data.file_url
      });
      console.log("linkform.file_ids->", linkform.file_ids);
    };
    // 添加任务
    var handle_add_tasks = () => {
      linkform.user_ids.push({
        title: "",
        finish_time: "",
        userids: [],
        type: 1
      });
    };
    // 发布
    var handle_submit = () => {
      console.log("发布->", linkform);
      if (dataOwn.submitTxt == "发布") {
        linkformref.value.validate(valid => {
          if (valid) {
            // 如果是样品返厂的待办 校验样样品申请单是否为空，若不存在，提示选择，并不能进入下一步操作
            console.log("success submit!");
            if (linkform.type == 2 && (!linkform.sample || !linkform.sample.id)) {
              console.log("linkform.sample->", linkform.sample);
              ElMessage({
                type: "error",
                message: "关联样品申请单不能为空"
              });
              return false;
            } else {
              dataOwn.submitTxt = "发布中...";
            }
            handle_create_link();
          } else {
            console.log("error submit!");
          }
        });
      }
    };
    // 创建link
    var handle_create_link = () => {
      // 定制品待办不再需要群组了 不需要在群组和个人中发送消息了哈

      var temp = JSON.parse(JSON.stringify(linkform));
      console.log("temp.user_ids->", temp);
      var tempUser = []; //link待办的所有任务执行人
      // 没有群组且待办不是物料定制待办
      if (!linkform.group_id && linkform.type != 3) {
        // 如果没有群组id,则需要创建群组 进一步判断是创建
        if ((linkform.source == 3 || linkform.source == 2 || linkform.source == 1 || linkform.source == 5 && linkform.type == 1) && linkform.sales_dept_id && linkform.origin_id && linkform.type == 1) {
          tempUser = dataOwn.userList.map(x => x.name);
        } else if (linkform.source == 6) {
          temp.user_ids.forEach(x => {
            var userids = x.userids;
            userids.map(m => {
              console.log("m-->", m);
              tempUser.push(m.split("-")[0]);
            });
          });
        }
        //  创建者也要塞进群组 否则消息无法发送
        if (tempUser.indexOf(userStore.info.name) == -1) {
          tempUser.push(userStore.info.name);
        }
        console.log("tempUser->", tempUser);
        createCustomerGroup(linkform.source == 6 ? "normal" : "custom", tempUser, dataOwn.clientName).then(resGroup => {
          console.log("创建群组成功->", resGroup);
          linkform.group_id = resGroup.data.group.groupID;
          handle_create_link_post();
          if (linkform.source == 3 || linkform.source == 2 || linkform.source == 1 || linkform.source == 5 && linkform.type == 1) {
            // source=3 时是跟客户做关联
            // 群组和客户做关联
            var obj_relate = {
              origin_id: linkform.origin_id,
              group_id: linkform.group_id,
              source: 3 //1 线索 2商机 3客户
            };
            create_group_link(obj_relate, "POST").then(res => {
              console.log("群组做关联");
            });
          }
        });
      } else {
        handle_create_link_post();
      }
    };
    // 添加群成员
    var addMember = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(function* (userIDList, groupID) {
        var options = {
          groupID: groupID,
          userIDList
        };
        yield TUIGroupService.addGroupMember(options);
      });
      return function addMember(_x, _x2) {
        return _ref2.apply(this, arguments);
      };
    }();
    // 创建或编辑待办（百林客）
    var handle_create_link_post = () => {
      var temp = JSON.parse(JSON.stringify(linkform));
      temp.user_ids.forEach(x => {
        if (dataOwn.isMoreLink) {
          delete x.task_id;
          delete x.id;
        }
        var userids = x.userids;
        var arr = [];
        userids.map(m => {
          console.log("m-->", m);
          arr.push({
            name: m.split("-")[0],
            id: Number(m.split("-")[1])
          });
        });
        x.userids = arr;
        if (x.task_id) {
          x.id = x.task_id ? x.task_id : "";
        }
      });
      console.log("temp.user_ids->", temp);
      if (linkform.type == 2) {
        // 是样品返厂
        temp.origin_id = linkform.sample.id;
        delete temp.sample;
        temp.bills_code = linkform.sample.bills_code;
      }
      console.log("temp-->", temp);
      temp.origin_id = temp.origin_id ? temp.origin_id : temp.group_id;
      if (dataOwn.link_id) {
        temp.id = dataOwn.link_id;
        if (!dataOwn.isMoreLink) {
          var _loop = function _loop() {
            var item = dataOwn.originLinkDeatil.user_ids[i];
            var index_n = temp.user_ids.findIndex(x => x.id == item.task_id);
            if (index_n != -1) {
              if (temp.user_ids[index_n].title == item.title) {
                // 说明此时无变化
                delete temp.user_ids[index_n].title;
              }
            }
          };
          // 需判断编辑前后user中的任务是否改变
          for (var i in dataOwn.originLinkDeatil.user_ids) {
            _loop();
          }
        }
      }
      var postParams = JSON.parse(JSON.stringify(temp));
      if (linkform.type == 3) {
        delete postParams["group_id"];
      }
      postParams.source = postParams.source == 1 || postParams.source == 2 || postParams.source == 5 && postParams.type == 1 ? 3 : postParams.source;
      if (dataOwn.isMoreLink) {
        change_link(postParams, "POST").then(res => {
          if (res.code == 200) {
            userStore.getInfo();
            dataOwn.submitTxt = "发布";
            emit("handle_close_linkDialog");
            // 通知父组件更新link列表
            emit("updateList");
            if (route.path != "/work_bench/link") {
              router.replace("/work_bench/link");
            }
          }
        });
      } else {
        create_link(postParams, dataOwn.link_id ? "PUT" : "POST").then(res => {
          if (res.code == 200) {
            console.log("创建或更新待办成功");
            userStore.getInfo();

            // 判断是否是定制品待办 若是定制品待办 到这一步就结束了
            if (linkform.type == 3) {
              dataOwn.submitTxt = "发布";
              emit("handle_close_linkDialog");
              // 通知父组件更新link列表
              emit("updateList");
              if (route.path != "/work_bench/link") {
                router.replace("/work_bench/link");
              }
              return false;
            }
            var sendCustomExtension = JSON.parse(JSON.stringify(temp));
            sendCustomExtension.link_id = dataOwn.link_id ? dataOwn.link_id : res.data.id;
            sendCustomExtension.type = sendCustomExtension.source;
            if (dataOwn.source_id) {
              sendCustomExtension.source_id = dataOwn.source_id;
            }

            // 发送link消息之前 需要看是否需要加入群组 校验任务执行人是否都在群组中，若不在，执行加人的操作

            if (dataOwn.fromGroup || linkform.sales_dept_id != 0 && linkform.sales_dept_id) {
              console.log("不需要执行加人的操作");
            } else {
              if (linkform.group_id && dataOwn.link_id) {
                TUIGroupService.getGroupMemberList({
                  groupID: linkform.group_id,
                  offset: 0,
                  count: 1000
                }).then(resMember => {
                  var groupMember = resMember.data.memberList;
                  var renwuMember = JSON.parse(JSON.stringify(temp.user_ids));
                  var renwu_user = [];
                  renwuMember.map(x => {
                    x.userids.map(m => {
                      renwu_user.push(m);
                    });
                  });
                  console.log("renwu_user  1---", renwu_user);
                  // 对任务涉及人员进行去重
                  removeRepeatKeyInArrKey(renwuMember, "link_user_id");
                  var need_add_user = [];
                  renwu_user.map(x => {
                    var index_has = groupMember.findIndex(m => x.name == m.userID);
                    if (index_has == -1) {
                      console.log("没找到，需要加到群组里面");
                      need_add_user.push(x.name);
                    }
                  });
                  console.log("need_add_user--->", need_add_user);
                  // 将其中已登录im的用户添加到该群组
                  if (need_add_user && need_add_user[0]) {
                    // 调用群成员添加的接口 将人员添加进去 先看能否获取用户列表
                    TUIUserService.getUserProfile({
                      userIDList: need_add_user
                    }).then(res_profile => {
                      console.log("res_profile--->", res_profile);
                      var names_ = res_profile.data.map(x => x.userID);
                      if (names_ && names_[0]) {
                        addMember(names_, linkform.group_id);
                      }
                    });
                  }
                });
              }
            }
            var to = linkform.group_id;
            var type = dataOwn.customMessageType;
            var extension = JSON.stringify(sendCustomExtension);
            var conversationType = "GROUP";
            var description = "Link";
            // 发送自定义消息
            var result = TimStore.TIMSendCustomMessage(to, type, extension, conversationType, description);
            console.log("result-->", result);
            dataOwn.submitTxt = "发布";
            emit("handle_close_linkDialog");
            commonStore.set_activenews("conversation");
            router.push("/instant_messages?groupID=".concat(linkform.group_id));
          }
        });
      }
    };

    //删除任务
    var handle_delate_renwu = i => {
      linkform.user_ids.splice(i, 1);
    };

    // 获取到的样品单据
    var getSelectSample = smaple => {
      dataOwn.showDialogSample = false;
      linkform.sample = smaple;
      console.log("linkform.sample-->", linkform.sample);
    };

    // 禁止某个时间不可选
    var handle_disable_date = date => {
      // 获取当前时间
      var timestamp = new Date().getTime() - 24 * 60 * 60 * 1000;
      if (date.getTime() < timestamp) {
        return true;
      } else {
        return false;
      }
    };
    var handle_picker_timeChange_t = () => {
      // 监听选择的时间
      if (linkform.date && !dataOwn.link_id) {
        for (var i in linkform.user_ids) {
          var item = linkform.user_ids[i];
          if (!item.finish_time) {
            linkform.user_ids[i].finish_time = linkform.date;
          }
        }
      }
    };
    var handle_preview = file => {
      var _file$response;
      console.log("打印file===", file);
      var url = ((_file$response = file.response) === null || _file$response === void 0 ? void 0 : _file$response.data.file_url) || file.url;
      console.log("url===", url);
      var eleLink = document.createElement("a");
      eleLink.href = url; // 触发点击
      eleLink.target = "target";
      document.body.appendChild(eleLink);
      eleLink.click(); // 然后移除
      document.body.removeChild(eleLink);
    };
    var handle_change = () => {
      selectpeople.value[0].query = "";
    };
    return (_ctx, _cache) => {
      var _component_el_input = __unplugin_components_0;
      var _component_el_form_item = __unplugin_components_1;
      var _component_el_option = __unplugin_components_2;
      var _component_el_select = __unplugin_components_3;
      var _component_el_date_picker = __unplugin_components_4;
      var _component_el_radio = __unplugin_components_5;
      var _component_el_radio_group = __unplugin_components_6;
      var _component_el_button = __unplugin_components_7;
      var _component_el_upload = __unplugin_components_8;
      var _component_el_form = __unplugin_components_9;
      var _component_el_dialog = __unplugin_components_10;
      var _component_client_project_dialog = __unplugin_components_11;
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_form, {
        ref_key: "linkformref",
        ref: linkformref,
        rules: rules,
        model: linkform,
        "label-width": "auto",
        style: {
          "max-width": "600px",
          "padding-right": "20px"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: dataOwn.customMessageType == 'link' ? '待办主题' : '协同主题',
          prop: "theme"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: linkform.theme,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => linkform.theme = $event),
            placeholder: "请输入主题",
            type: "text",
            autocomplete: "off"
          }, null, 8, ["modelValue"])]),
          _: 1
        }, 8, ["label"]), _createVNode(_component_el_form_item, {
          label: dataOwn.customMessageType == 'material_customization' ? '客户需求' : dataOwn.customMessageType == 'demo' ? '样品返厂原因' : '待办描述',
          prop: "title"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: linkform.title,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => linkform.title = $event),
            type: "textarea",
            placeholder: "请输入",
            autosize: "",
            autocomplete: "off"
          }, null, 8, ["modelValue"])]),
          _: 1
        }, 8, ["label"]), __props.linkParams.project_show ? (_openBlock(), _createBlock(_component_el_form_item, {
          key: 0,
          label: "客户项目",
          prop: "client_project_id"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_select, {
            modelValue: linkform.client_project_id,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => linkform.client_project_id = $event),
            filterable: "",
            placeholder: "请选择客户项目",
            style: {
              "width": "90%"
            },
            "value-key": "FNumber"
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(client_project_list), item => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: item.id,
                label: item.project,
                value: item.id
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"]), _createElementVNode("span", {
            class: "client_add iconfont icon-a-zengjiatianjiajiahaoduo",
            onClick: addClientProject
          })])]),
          _: 1
        })) : _createCommentVNode("", true), _createVNode(_component_el_form_item, {
          label: dataOwn.customMessageType == 'material_customization' ? '期望完成时间' : dataOwn.customMessageType == 'demo' ? '预计返厂时间' : '截止时间',
          prop: "date"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_date_picker, {
            "disabled-date": handle_disable_date,
            style: {
              "width": "100%"
            },
            shortcuts: shortcuts,
            modelValue: linkform.date,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => linkform.date = $event),
            type: "datetime",
            placeholder: "请选择时间",
            format: "YYYY/MM/DD HH:mm",
            "value-format": "YYYY/MM/DD HH:mm",
            onChange: handle_picker_timeChange_t
          }, null, 8, ["modelValue"])]),
          _: 1
        }, 8, ["label"]), dataOwn.customMessageType == 'demo' ? (_openBlock(), _createBlock(_component_el_form_item, {
          key: 1,
          label: "关联样品申请单"
        }, {
          default: _withCtx(() => {
            var _linkform$sample;
            return [_createElementVNode("p", {
              class: "blk_link",
              style: {
                "cursor": "pointer"
              },
              onClick: _cache[4] || (_cache[4] = $event => dataOwn.showDialogSample = true)
            }, " 样品申请单号：" + _toDisplayString(linkform === null || linkform === void 0 || (_linkform$sample = linkform.sample) === null || _linkform$sample === void 0 ? void 0 : _linkform$sample.bills_code), 1)];
          }),
          _: 1
        })) : _createCommentVNode("", true), dataOwn.customMessageType == 'material_customization' ? (_openBlock(), _createBlock(_component_el_form_item, {
          key: 2,
          label: " 是否可以查看图纸"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_radio_group, {
            modelValue: linkform.view_drawing,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => linkform.view_drawing = $event)
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio, {
              value: 1,
              size: "large"
            }, {
              default: _withCtx(() => _cache[9] || (_cache[9] = [_createTextVNode("是")])),
              _: 1
            }), _createVNode(_component_el_radio, {
              value: 2,
              size: "large"
            }, {
              default: _withCtx(() => _cache[10] || (_cache[10] = [_createTextVNode("否")])),
              _: 1
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        })) : _createCommentVNode("", true), _createVNode(_component_el_form_item, {
          label: "附件",
          prop: "file_ids"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_upload, {
            class: "uploadlink upload-demo",
            "file-list": _unref(fileList),
            "onUpdate:fileList": _cache[6] || (_cache[6] = $event => _isRef(fileList) ? fileList.value = $event : null),
            multiple: "",
            action: action,
            headers: headers,
            name: "file",
            "on-remove": handleFileRemove,
            "on-preview": handle_preview,
            "on-success": handleFileSuccess,
            data: {
              content_type: 5
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              type: "primary"
            }, {
              default: _withCtx(() => _cache[11] || (_cache[11] = [_createTextVNode("点击上传")])),
              _: 1
            })]),
            _: 1
          }, 8, ["file-list"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: dataOwn.customMessageType == 'link' ? '任务' : '协同任务',
          prop: "user_ids"
        }, {
          default: _withCtx(() => [dataOwn.customMessageType == 'link' || dataOwn.customMessageType == 'material_customization' ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: "iconfont icon-tianjia1",
            onClick: handle_add_tasks
          })) : _createCommentVNode("", true), linkform !== null && linkform !== void 0 && linkform.user_ids && linkform.user_ids[0] ? (_openBlock(), _createElementBlock("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(linkform.user_ids, (v, i) => {
            return _openBlock(), _createElementBlock("div", {
              key: i,
              style: {
                "padding-top": "1px",
                "border-radius": "5px"
              }
            }, [_createElementVNode("p", _hoisted_4, _toDisplayString(getTypeLabel(v.type)), 1), _createVNode(_component_el_select, {
              onChange: handle_change,
              ref_for: true,
              ref_key: "selectpeople",
              ref: selectpeople,
              multiple: "",
              modelValue: v.userids,
              "onUpdate:modelValue": $event => v.userids = $event,
              filterable: "",
              placeholder: "请选择执行人",
              size: "large",
              style: {
                "width": "100%"
              }
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataOwn.userList, item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.id,
                  label: item.name,
                  value: item.value_show
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 2
            }, 1032, ["modelValue", "onUpdate:modelValue"]), _createVNode(_component_el_date_picker, {
              style: {
                "width": "100%",
                "margin": "5px 0"
              },
              shortcuts: shortcuts,
              modelValue: v.finish_time,
              "onUpdate:modelValue": $event => v.finish_time = $event,
              type: "datetime",
              format: "YYYY/MM/DD HH:mm",
              "value-format": "YYYY/MM/DD HH:mm",
              placeholder: "请选择时间",
              "disabled-date": handle_disable_date
            }, null, 8, ["modelValue", "onUpdate:modelValue"]), _createVNode(_component_el_input, {
              placeholder: "请输入任务",
              disabled: dataOwn.customMessageType == 'link' || v.type == 1 ? false : true,
              modelValue: v.title,
              "onUpdate:modelValue": $event => v.title = $event
            }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"]), v.type == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("span", {
              onClick: $event => handle_delate_renwu(i),
              style: {
                "font-size": "20px"
              },
              class: "iconfont icon-shanchu"
            }, null, 8, _hoisted_6)])) : _createCommentVNode("", true)]);
          }), 128))])) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["label"])]),
        _: 1
      }, 8, ["rules", "model"]), _createElementVNode("div", _hoisted_7, [linkform.type != 3 ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_cache[12] || (_cache[12] = _createElementVNode("span", null, "推送到群聊   ", -1)), _createVNode(_component_el_select, {
        style: {
          "width": "10em"
        },
        modelValue: linkform.view_status,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => linkform.view_status = $event),
        clearable: "",
        placeholder: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_option, {
          label: "所有群成员",
          value: 1
        }), _createVNode(_component_el_option, {
          label: "仅待办参与人",
          value: 2
        })]),
        _: 1
      }, 8, ["modelValue"]), _cache[13] || (_cache[13] = _createTextVNode("  可见   "))])) : _createCommentVNode("", true), _createElementVNode("span", {
        class: "submit",
        onClick: handle_submit
      }, _toDisplayString(dataOwn.submitTxt), 1)])]), _createVNode(_component_el_dialog, {
        width: "900",
        "destroy-on-close": "",
        modelValue: dataOwn.showDialogSample,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => dataOwn.showDialogSample = $event),
        "append-to-body": true,
        title: "选择样品申请单"
      }, {
        default: _withCtx(() => [dataOwn.clientID ? (_openBlock(), _createBlock(sampleDialog, {
          key: 0,
          clientID: dataOwn.clientID,
          onGetSelectSample: getSelectSample
        }, null, 8, ["clientID"])) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["modelValue"]), _unref(showDialog) ? (_openBlock(), _createBlock(_component_client_project_dialog, {
        key: 0,
        isShow: _unref(showDialog),
        onOnClose: handle_close_client,
        id: __props.linkParams.client_id
      }, null, 8, ["isShow", "id"])) : _createCommentVNode("", true)], 64);
    };
  }
};